<script>
export default {
  props: {
    updating: {
      type: Boolean,
    },
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<template>
    <div class="table-responsive">
        <table class="table table-centered">
        <tbody>
            <tr v-for="(item, index) in items" :key="index">
                <td class="w-100">
                    <p class="mb-0">{{ item.nom }}</p>
                </td>
                <td>
                    <div class="d-flex align-items-center">
                        <b-progress :value="item.taux" :variant="item.taux < 50 ? 'warning' : 'primary'" height="6px" style="width: 80px;"/>
                        <small class="ml-2">{{ item.taux }}%</small>
                    </div>
                </td>
            </tr>
        </tbody>
        </table>
    </div>
</template>

<style scoped>
.progress {
    background: #ddd;
}
</style>
